import React, { useEffect, useState } from "react";
import "./nuestra-historia.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock as faClockRegular } from '@fortawesome/free-regular-svg-icons';
import { getTarjetasInicio } from "../../config/services/strapi/home";
import { getHistoriaTimeline } from "../../config/services/strapi/nuestra-historia";
import TextSkeleton from "../../components/Skeleton/TextSkeleton";
import ImageSkeleton from "../../components/Skeleton/ImageSkeleton";
import CardSkeleton from "../../components/Skeleton/CardSkeleton";

const TimelineItem = ({ item, index, onImageClick }: { item: any, index: number, onImageClick: (url: string) => void }) => {
  const isEven = index % 2 === 0;
  const color = isEven ? '#ed7d32' : '#e8a438';
  const sideClass = isEven ? 'derecha' : 'izquierda';
  
  const desc = item.descripcionImage?.[0]?.children?.[0]?.text || "";
  const imgUrl = item.image?.url || "";

  return (
    <div className={`contenedor-timeline-item ${sideClass}`}>
      <div className="timeline-line-main"></div>
      <div className="timeline-dot">
        <div className="dot-inner" style={{ backgroundColor: color }}>
          <FontAwesomeIcon icon={faClockRegular} className="icono-reloj-blanco" />
        </div>
      </div>

      <div className="columna-contenido">
        <div className="box-titulo-container" style={{ backgroundColor: color }}>
          <span className="year-text-inline">{item.anoImage}</span>
          <h2 className="timeline-h2-inline">{item.tituloImage}</h2>
        </div>

        <div className="wrapper-imagen-timeline" onClick={() => onImageClick(imgUrl)} style={{ cursor: 'zoom-in' }}>
          <img src={imgUrl} alt={item.tituloImage} className="imagen-adaptable" />
        </div>

        <div className="box-descripcion">
          <p className="texto-descripcion-gray">{desc}</p>
        </div>
      </div>
    </div>
  );
};

export default function NuestraHistoria() {
  const [selectedImg, setSelectedImg] = useState<string | null>(null);
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [heroData, setHeroData] = useState<any>(null);
  const [timelineData, setTimelineData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  const heroBg = heroData?.portada?.url ? `url(${heroData.portada.url})` : "none";

  useEffect(() => {
    async function loadData() {
      try {
        const [tarjetas, historia] = await Promise.all([
          getTarjetasInicio(),
          getHistoriaTimeline(),
        ]);

        const tarjetaHero = tarjetas.find((t: any) =>
          t.titulo?.toUpperCase() === "NUESTRA HISTORIA" || t.Titulo?.toUpperCase() === "NUESTRA HISTORIA"
        );
        setHeroData(tarjetaHero);

        const ordenados = [...historia].sort((a: any, b: any) => 
          parseInt(a.anoImage) - parseInt(b.anoImage)
        );

        setTimelineData(ordenados);
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, []);

  const renderHeroTitle = () => {
    if (loading) return "NUESTRA HISTORIA";
    const texto = heroData?.titulo || heroData?.Titulo || "NUESTRA HISTORIA";

    return texto.split(" ").map((w: string, i: number) => (
      <React.Fragment key={i}>
        {w} {i === 0 && <br />}
      </React.Fragment>
    ));
  };

  return (
    <>
      <section className="section-nuestra-historia">
        <div className="section-inner-nuestra-historia">
          <div className="col-text-nuestra-historia nuestra-historia">
            {loading ? <TextSkeleton /> : <h1>{renderHeroTitle()}</h1>}
          </div>
          <div className="col-media-nuestra-historia">
            {loading ? (
              <ImageSkeleton className="h-full" />
            ) : (
              <div className="media-cover-nuestra-historia" style={{ backgroundImage: heroBg }} />
            )}
          </div>
        </div>
      </section>

      <section className="section-principal-nuestra-historia">
        <div className="contenedor-nuestra-historia">
          <div className="columna-texto-nuestra-historia">
            <p className="texto-descripcion-nuestra-historia">
              En Parque de los Gasómetros queremos escribir una nueva historia
              para la Fábrica de Gas San Borja, que en 1910 comenzó a abastecer
              de energía a la ciudad de Santiago. Con el tiempo fue aumentando
              su capacidad, hasta que en 1930 consolidó sus operaciones con sus
              tres gasómetros, que pronto se convirtieron en íconos urbanos de
              la ciudad. El año 2015 se dio término a la producción y
              distribución del gas de ciudad en las instalaciones de la ex
              Fábrica, lo que llevó a Empresas Gasco a desarrollar un proyecto
              que pone en valor su legado de manera sostenible e integral.
            </p>
          </div>
        </div>
      </section>

      <section className="section-principal-nuestra-historia">
        <div className="contenedor-encabezado-nuestra-historia">
          <h3 className="titulo-section-verde-nuestra-historia">
            <strong>Línea de Tiempo</strong>
          </h3>
        </div>
      </section>

      <section className="section-principal-nuestra-historia timeline-wrapper">
        <div className="timeline-container">
          {loading
            ? Array.from({ length: 3 }).map((_, index) => (
              <CardSkeleton key={`timeline-skeleton-${index}`} className="max-w-full" />
            ))
            : timelineData.map((item, index) => (
              <TimelineItem 
                key={item.id || index} 
                item={item} 
                index={index} 
                onImageClick={(url) => {
                  setIsLoadingModal(true);
                  setSelectedImg(url);
                }} 
              />
            ))}
        </div>
      </section>

      {selectedImg && (
        <div className="modal-overlay" onClick={() => setSelectedImg(null)}>
          {isLoadingModal && <div className="modal-loader"></div>}
          <div className={`modal-content ${!isLoadingModal ? 'visible' : ''}`} onClick={(e) => e.stopPropagation()}>
            <img src={selectedImg} alt="Ampliación" onLoad={() => setIsLoadingModal(false)} />
            {!isLoadingModal && (
              <div className="pp_details">
                <a className="pp_close" href="#!" onClick={(e) => { e.preventDefault(); setSelectedImg(null); }}>Close</a>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}